import React from 'react';
import { Say } from '../widgets/Say';
import { SayRP } from './SayRP';

/** show some samples from a few lexical sets and how they sound in GA & RP */
export function SampleLexicalSets() {
  return (<table>
    <thead><tr><td>name</td><td>Western US</td><td>Received Pronunciation</td></tr></thead>
    <tbody>
      <tr>
        <th>lot</th>
        <td><Say>[ˈɫɑt]</Say> <Say>stop</Say> <Say>sock</Say> <Say>dodge</Say> <Say>romp</Say></td>
        <td><SayRP>[ˈɫɒt]</SayRP> <SayRP>stop</SayRP> <SayRP>sock</SayRP> <SayRP>dodge</SayRP> <SayRP>romp</SayRP></td>
      </tr>
      <tr>
        <th>thought</th>
        <td><Say>[ˈθɑt]</Say> <Say>taught</Say> <Say>sauce</Say> <Say>hawk</Say> <Say>jaw</Say></td>
        <td><SayRP>[ˈθɔːt]</SayRP> <SayRP>taught</SayRP> <SayRP>sauce</SayRP> <SayRP>hawk</SayRP> <SayRP>jaw</SayRP></td>
      </tr>
      <tr>
        <th>force</th>
        <td><Say>[ˈfoɹs]</Say> <Say>four</Say> <Say>wore</Say> <Say>sport</Say> <Say>porch</Say></td>
        <td><SayRP>[ˈfɔːs]</SayRP> <SayRP>four</SayRP> <SayRP>wore</SayRP> <SayRP>sport</SayRP> <SayRP>porch</SayRP></td>
      </tr>
    </tbody>
  </table>
  );
}
